// OPENING + SLIDER
import {
  Pla
} from './pla.js'; // URLパラメータ

export class Opening {
  constructor(env) {

    this.envRef = env;
    //this.env = {}
    //this.main = mainObj;

    this.body = {}
    this.html = {}
    this.paramAncher = {}
    this.slider = {}
    this.sliderTimer = {};
  }

  init() {
    this.body = document.getElementsByTagName('body')[0];
    this.html = document.getElementsByTagName('html')[0];

    // 環境
    //this.env = new Env();
    //this.env.detectEnv();
    //console.log(this.envRef.ua);
    //console.log(this.envRef.browser.chrome);

    // URLパラメータ
    this.paramAncher = new Pla();
    this.paramAncher.getParam('op', location.href);

    if (document.getElementById('Index-cover')) {
      if (this.envRef.browser.ie11 || this.paramAncher.param == 0) {
        // Openingなし
        //document.getElementById('cover-basic').classList.add('show');
        document.getElementById('Index-opening').classList.add('hide');
        this.showMainContent();
        window.setTimeout(() => { //function() {
          this.body.classList.add('opening-skipped');
        }, 300);
      } else {
        this.flg = true;
      }
    }

    this.initSlider();
  }


  // OPENING
  // --------
  finishedOpening() {
    //console.log('Opening Finished');
    window.scrollBy(0, 1);
  }

  startOpening() {
    if (document.getElementById('Index-opening')) {
      // Opening開始
      //document.getElementById('Index-opening').classList.add('show');
      //console.log('Opening開始');

      let baseTime = 300;
      window.setTimeout(() => {
        document.getElementById('Index-opening').querySelector('.Index-opening__logo').classList.remove('hide');
        const myVivus = new Vivus('logo-1', {
          type: 'scenario',
          duration: 80,
          animTimingFunction: Vivus.EASE_OUT,
        }, this.openingLogoCallback);
        let targets = document.getElementById('logo-1').querySelectorAll('.cls-3');
        for (let i = 0; i < targets.length; i++) {
          targets[i].classList.add('show');
        }
        this.finishedOpening();
      }, 300);

      window.setTimeout(() => { //function() {
        document.getElementById('Index-opening').querySelector('.Index-opening__logo').classList.add('hide');
        this.showMainContent();
      }, baseTime + 2400);

      //その後に opening-finished追加
      window.setTimeout(() => { //function() {
        this.body.classList.add('opening-finished');
        this.startSlider();
      }, baseTime + 2700);

      window.setTimeout(() => { //function() {
        document.getElementById('Index-opening').classList.add('hide');
      }, baseTime + 3300);

    }
  }

  skipOpening() {
    this.body.classList.add('opening-skipped');
    this.startSlider();
  }

  showMainContent() {
    let template;
    let clone;

    // HomeのOP以下のコンテンツ
    if (document.getElementById('index-content-template')) {
      template = document.getElementById('index-content-template');
      clone = template.content.cloneNode(true);
      document.getElementById('index-content-to-append').appendChild(clone);
    }
  }

  // SLIDER
  // --------
  initSlider() {
    this.slider.status = -1;
    if (document.getElementById('Index-cover')) {
      this.slider.elems = document.querySelectorAll('#Index-cover .js-index-cover-resizer');
      this.slider.pagers = document.getElementById('Index-cover').querySelectorAll('.Index-cover-slider__pagination .Index-cover-slider__pagination-bullet');
    }
    //console.log('initSlider');
    //console.log(this.slider.pagers);
  }

  startSlider() {
    //console.log(this.slider.status);

    // 初回 transitionのみ
    this.slider.statusThen = 3;
    this.slider.status = 0;

    let sliderDuration = 4000;
    let windowWidth = (window.innerWidth || document.documentElement.clientWidth || 0);
    if (windowWidth > 800) {
      sliderDuration = 5000;
    }

    console.log(this.slider.elems);

    this.slider.elems[0].querySelectorAll('.Index-cover-slider-bg')[0].classList.add('active');

    // auto slide 開始
    this.sliderTimer = setInterval(() => {
      this.changeSlider();
    }, sliderDuration);

    // window.setTimeout(() => {
    //   clearInterval(this.sliderTimer);
    // }, 100);
  }

  changeSlider() { //after transition
    for (let i = 0; i < this.slider.elems.length; i++) {
      this.slider.elems[i].classList.remove('hide-width');
      //const remClass = new RegExp(/\bjs-index-cover-resizer-z-.+?\b/, 'g');
      //const remClass = new RegExp(/\bjs-index-cover-resizer-z-.+?\b/, 'g');
      const remClass = {};
      if (this.envRef.browser.ie11) {
        remClass = new RegExp("js-index-cover-resizer-z-.+?", 'g');
      } else {
        remClass = new RegExp(/\bjs-index-cover-resizer-z-.+?\b/, 'g');
      }
      if (this.slider.elems[i].className.match(remClass)) {
        this.slider.elems[i].className = this.slider.elems[i].className.replace(remClass, '');
      }

      if (this.slider.status !== i) {
        this.slider.elems[i].querySelectorAll('.Index-cover-slider-bg')[0].classList.remove('active');
      }

      // pager
      // console.log(this.slider.pagers[i]);
      this.slider.pagers[i].classList.remove('Index-cover-slider__pagination-bullet--active');
    }

    if (this.slider.status >= 0) {

      this.slider.statusThen = this.slider.status;
      // 2回目以降 写真重ね順変更 + transition
      if (this.slider.status < 3) {
        this.slider.status++;
      } else {
        this.slider.status = 0;
      }
      //console.log('TRANSITION中' + this.slider.statusThen + ' -> NEXT: ' + this.slider.status);

      //console.log('this.slider.status = ' + this.slider.status);
      for (let i = 0; i < this.slider.elems.length; i++) {
        //console.log(this.slider.elems[i]);

        // 重ね順 
        // -------
        // これから消すもの
        this.slider.elems[this.slider.statusThen].classList.add('js-index-cover-resizer-z-11');
        this.slider.elems[this.slider.statusThen].classList.add('hide-width');

        // 次に出るもの
        this.slider.elems[this.slider.status].classList.add('js-index-cover-resizer-z-10');
        this.slider.elems[this.slider.status].querySelectorAll('.Index-cover-slider-bg')[0].classList.add('active');
        //this.slider.elems[i].classList.add('js-index-cover-resizer-z-' + (this.slider.elems.length - i));

        this.slider.pagers[this.slider.status].classList.add('Index-cover-slider__pagination-bullet--active');
      }


    }

  }
}